export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/payment-log-x-circle.705fe914.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};